module.exports = __webpack_public_path__ + "static/media/alignRight.90f503f3.svg";